import { render } from "./MainNavigationSlot.vue?vue&type=template&id=239dfc90"
import script from "./MainNavigationSlot.vue?vue&type=script&lang=js"
export * from "./MainNavigationSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__